import {InferType, boolean, object, string, mixed} from 'yup';
import {ValidationMessage} from '$constants/messages';

export const gpOrOpticianReferralFormSchema = object({
  hasReferral: boolean().required(ValidationMessage.SelectOption),
  bookingReason: string()
    .trim()
    .max(300, ValidationMessage.BookingReasonExceedCharacterLimit),
  referralFile: mixed().when('hasReferral', {
    is: true,
    then: schema =>
      schema.nullable().test('', ValidationMessage.ReferralFileSize, value => {
        if (!value) return true;
        const file = value as File;
        const fileSize = file.size / (1024 * 1024);

        return fileSize <= 5;
      }),
    otherwise: schema => schema.notRequired(),
  }),
});

export type GPOrOpticianReferralValidatedFormData = Omit<
  InferType<typeof gpOrOpticianReferralFormSchema>,
  'referralFile'
> & {referralFile?: File};

export interface GPOrOpticianReferralFormData {
  hasReferral: boolean | null;
  bookingReason?: string;
  referralFile?: File | null;
}
